// this is an autogenerated file from App/Account/EmbeddableCoreMessageListener/PaymentsCreateInvoice/Charges/Charge/Type/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_EmbeddableCoreMessageListener_PaymentsCreateInvoice_Charges_Charge_Type($location_id: uuid!) {
  vaxiom_misc_fee_charge_templates(
    where: { organization: { _id: { _eq: $location_id } } }
    order_by: { name: asc_nulls_last }
  ) {
    id
    text: name
    name
    price
    affecting_production_report
  }
}

`